<div class="p-6 space-y-6" id="page-gestores">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Gestores</h2>
      <p class="text-sm text-gray-400 dark:text-gray-500">Equipo de gestores de la consultoría</p>
    </div>
    <button type="button" class="btn btn-primary gap-2 w-full sm:w-auto">
      <svg class="w-4 h-4"><use href="/svg/sprite.svg#plus-sign"/></svg>
      Nuevo Gestor
    </button>
  </div>

  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-800 flex flex-col lg:flex-row gap-3">
      <label class="input w-full lg:flex-1">
        <svg class="w-4 h-4 opacity-50"><use href="/svg/sprite.svg#search-icon"/></svg>
        <input type="text" placeholder="Buscar gestor..." class="grow" />
      </label>
      <select class="select w-full sm:w-auto">
        <option>Especialidad: Todas</option>
        <option>Gestor Senior</option>
        <option>Gestor Junior</option>
      </select>
      <select class="select w-full sm:w-auto">
        <option>Estado: Todos</option>
        <option>Activo</option>
        <option>Vacaciones</option>
        <option>Inactivo</option>
      </select>
    </div>

    <div class="p-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div class="bg-base-100 dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="flex items-start gap-4">
          <img alt="gestor" src="/img/default-avatar.png" class="object-cover w-12 h-12 rounded-xl" />
          <div class="min-w-0 flex-1">
            <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h4 class="font-bold text-gray-800 dark:text-white">Lic. Carlos Méndez</h4>
                <p class="text-xs text-primary font-medium">Gestor Senior</p>
              </div>
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg font-medium dark:text-green-400 w-fit">Activo</span>
            </div>
            <div class="mt-4 space-y-2 text-xs text-gray-500 dark:text-gray-400">
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                carlos.mendez&#64;gestormx.com
              </p>
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                +52 55 1234 5678
              </p>
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
                12 proyectos activos
              </p>
            </div>
          </div>
        </div>
        <div class="mt-4 flex flex-col sm:flex-row gap-2">
          <button type="button" class="btn btn-ghost flex-1">Editar</button>
          <button type="button" class="btn btn-error btn-outline flex-1">Desactivar</button>
        </div>
      </div>

      <div class="bg-base-100 dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="flex items-start gap-4">
          <img alt="gestor" src="/img/default-avatar.png" class="object-cover w-12 h-12 rounded-xl" />
          <div class="min-w-0 flex-1">
            <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h4 class="font-bold text-gray-800 dark:text-white">Arq. Laura Sánchez</h4>
                <p class="text-xs text-secondary font-medium">Gestor Junior</p>
              </div>
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg font-medium dark:text-green-400 w-fit">Activo</span>
            </div>
            <div class="mt-4 space-y-2 text-xs text-gray-500 dark:text-gray-400">
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                laura.sanchez&#64;gestormx.com
              </p>
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                +52 55 9876 5432
              </p>
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
                6 proyectos activos
              </p>
            </div>
          </div>
        </div>
        <div class="mt-4 flex flex-col sm:flex-row gap-2">
          <button type="button" class="btn btn-ghost flex-1">Editar</button>
          <button type="button" class="btn btn-error btn-outline flex-1">Desactivar</button>
        </div>
      </div>

      <div class="bg-base-100 dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="flex items-start gap-4">
          <img alt="gestor" src="/img/default-avatar.png" class="object-cover w-12 h-12 rounded-xl" />
          <div class="min-w-0 flex-1">
            <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h4 class="font-bold text-gray-800 dark:text-white">Ing. Pedro Rojas</h4>
                <p class="text-xs text-secondary font-medium">Gestor Junior</p>
              </div>
              <span class="text-xs bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 px-2 py-0.5 rounded-lg font-medium dark:text-yellow-400 w-fit">Vacaciones</span>
            </div>
            <div class="mt-4 space-y-2 text-xs text-gray-500 dark:text-gray-400">
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                pedro.rojas&#64;gestormx.com
              </p>
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                +52 81 2345 6789
              </p>
              <p class="flex items-center gap-2">
                <svg class="w-4 h-4 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
                4 proyectos activos
              </p>
            </div>
          </div>
        </div>
        <div class="mt-4 flex flex-col sm:flex-row gap-2">
          <button type="button" class="btn btn-ghost flex-1">Editar</button>
          <button type="button" class="btn btn-error btn-outline flex-1">Desactivar</button>
        </div>
      </div>
    </div>
  </div>
</div>

